// SPDX-License-Identifier: AGPL-3.0-or-later
import {getStatusGeometry} from '@app/features/ui/constants/AvatarStatusGeometry';
import {TYPING_BRIDGE_RIGHT_SHIFT_RATIO, TYPING_WIDTH_MULTIPLIER} from '@app/features/ui/constants/TypingConstants';
export interface AvatarStatusLayout {
	supportsStatus: boolean;
	statusSize: number;
	borderSize: number;
	statusWidth: number;
	statusHeight: number;
	typingWidth: number;
	typingHeight: number;
	innerStatusWidth: number;
	innerStatusHeight: number;
	innerTypingWidth: number;
	innerTypingHeight: number;
	statusRight: number;
	statusBottom: number;
	typingRight: number;
	innerStatusRight: number;
	innerStatusBottom: number;
	innerTypingRight: number;
	innerTypingBottom: number;
	cutoutCx: number;
	cutoutCy: number;
	cutoutRadius: number;
	typingCutoutCx: number;
	typingCutoutCy: number;
	typingCutoutWidth: number;
	typingCutoutHeight: number;
	typingCutoutRx: number;
}
export function getAvatarStatusLayout(size: number, isMobile: boolean = false): AvatarStatusLayout {
	const supportsStatus = size > 16;
	const geom = getStatusGeometry(size, isMobile);
	const statusSize = geom.size;
	const borderSize = geom.borderWidth;
	const statusWidth = statusSize;
	const statusHeight = isMobile && geom.phoneHeight ? geom.phoneHeight : statusSize;
	const typingWidth = Math.round(statusSize * TYPING_WIDTH_MULTIPLIER);
	const typingHeight = statusSize;
	const innerStatusWidth = statusSize;
	const innerStatusHeight = isMobile && geom.phoneHeight ? geom.phoneHeight : statusSize;
	const innerTypingWidth = typingWidth;
	const innerTypingHeight = typingHeight;
	const cutoutCx = geom.cx;
	const cutoutCy = geom.cy;
	const cutoutRadius = geom.radius;
	const typingCutoutWidth = typingWidth;
	const typingCutoutHeight = typingHeight;
	const typingExtension = Math.max(0, typingWidth - statusSize);
	const typingBridgeShift = typingExtension * TYPING_BRIDGE_RIGHT_SHIFT_RATIO;
	const typingCutoutCx = cutoutCx + statusSize / 2 - typingWidth / 2 + typingBridgeShift;
	const typingCutoutCy = cutoutCy;
	const typingCutoutRx = geom.radius;
	const innerStatusRight = size - cutoutCx - statusSize / 2;
	const innerStatusBottom = size - cutoutCy - statusHeight / 2;
	const innerTypingRight = innerStatusRight - typingBridgeShift;
	const innerTypingBottom = size - cutoutCy - typingHeight / 2;
	const statusRight = innerStatusRight;
	const statusBottom = innerStatusBottom;
	const typingRight = innerTypingRight;
	return {
		supportsStatus,
		statusSize,
		borderSize,
		statusWidth,
		statusHeight,
		typingWidth,
		typingHeight,
		innerStatusWidth,
		innerStatusHeight,
		innerTypingWidth,
		innerTypingHeight,
		statusRight,
		statusBottom,
		typingRight,
		innerStatusRight,
		innerStatusBottom,
		innerTypingRight,
		innerTypingBottom,
		cutoutCx,
		cutoutCy,
		cutoutRadius,
		typingCutoutCx,
		typingCutoutCy,
		typingCutoutWidth,
		typingCutoutHeight,
		typingCutoutRx,
	};
}
